// extracted by mini-css-extract-plugin
export var form = "_4o-0";